import * as types from './types';
import { loading } from 'State/actions';
import { validate } from 'Common/ReduxFormSubmitValidation';

const success = (type, payload) => {
  return { type, payload };
};

const errorResult = (type, payload) => {
  return { type, payload };
};

export const setVerificationType = value => {
  return {
    type: types.VERIFICATION_CONFIG_SET_TYPE,
    payload: value,
  };
};

export const fetchData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_CONFIG_FETCHING, true));

    try {
      const ciResponse = await MPWWebApi.getGeneric(`ControlInfo/1`);
      const vsResponse = await MPWWebApi.getGeneric(
        'ControlInfo/VerificationStatus'
      );

      dispatch(
        success(types.VERIFICATION_CONFIG_FETCH, {
          controlInfo: {
            ...ciResponse.data.Data,
            verificationStatus: vsResponse.data.Data,
          },
        })
      );
    } catch (error) {
      dispatch(errorResult(types.VERIFICATION_CONFIG_FETCH_ERROR, error));
    }

    dispatch(loading(types.VERIFICATION_CONFIG_FETCHING, false));
  };
};

export const saveData = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_CONFIG_SUBMITTING, true));

    await validate(
      dispatch,
      MPWWebApi,
      'ControlInfo/VerificationConfig/Validate',
      model,
      types.VERIFICATION_CONFIG_SUBMITTING
    );

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'ControlInfo/VerificationConfig',
        model
      );

      dispatch(success(types.VERIFICATION_CONFIG_SUBMIT));
      dispatch(fetchData());
    } catch (error) {
      dispatch(errorResult(types.VERIFICATION_CONFIG_SUBMIT_ERROR, error));
    }

    dispatch(loading(types.VERIFICATION_CONFIG_SUBMITTING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/state/configuration/actions.js